var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTombstoneSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75V17.7497H17V0.75H0ZM11.7692 12.5189H5.22947V5.97914H11.7692V12.5189Z",
    fill: "#E79836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTombstoneSymbol);
export default __webpack_public_path__ + "static/media/tombstoneSymbol.81d4363f7d92ed5b7caa8610268ac609.svg";
export { ForwardRef as ReactComponent };